export default "__VITE_PUBLIC_ASSET__e90db17a__"